<template>
	<div class='promise-wrap'>
		<h1>我的反馈</h1>
		<div class="promise-table">
			<div class="flex flex-row-between promise-header">
				<p>序号</p>
				<p>意见标题</p>
				<p>提交时间</p>
				<p>状态</p>
				<p>操作</p>
			</div>
			<template v-for="(item, index) in list">
				<div class="flex flex-row-between promise-tbody" :key="item.id">
					<p>{{index+1}}</p>
					<p>{{item.title}}</p>
					<p>{{item.creatortime}}</p>
					<p>{{formatRemark(item.enabledmark)}}</p>
					<p @click="showItemHandle(item)">{{!item.show?'查看详情':'收起'}}</p>
				</div>
				<div class="promise-reply" :key="item.id" v-if="item.show">
					<p>意见内容：{{item.content}}</p>
					<p><span>答复日期：</span>{{item.lastmodifytime||'---'}}</p>
					<p><span>答复内容：</span>{{item.replycontent||'---'}}</p>
				</div>
			</template>

		</div>

		<el-pagination v-if="list.length>0" background layout="total, prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange" />

		<empty v-if="!list.length" />
	</div>
</template>

<script>
import { queryFeedBack } from '@/api';
import empty from '@/components/empty'
export default {
	components: {
		empty,
	},
	data() {
		return {
			list: [],
			total: 0,
			pageSize: 10,
			current: 1
		}
	},
	created() {
		const { path } = this.$route;

		this.$emit('userEmit', path)
	},
	mounted() {
		this.getFeedBackList(1)
	},
	methods: {
		getFeedBackList(page = 1) {
			queryFeedBack({ current: page }).then(res => {
				const { total, current, records, size, } = res;
				this.$set(this, 'current', this.page);
				this.$set(this, 'total', total || 0);
				this.$set(this, 'pageSize', size || 10);
				this.$set(this, 'list', records || []);
			})
		},
		handleCurrentChange(e) {
			this.getFeedBackList(e);
		},
		formatRemark(remark) {
			// 0=已提交,1=已回复,2=未采纳",
			switch (+remark) {
				case 0:
					return '已提交';
				case 1:
					return '已回复';
				case 2:
					return '未采纳';
				default:
					return '';
			}
		},
		showItemHandle(row) {
			this.$set(row, 'show', !row.show);
		}
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' scoped>
	.promise-wrap {
		padding-left: 20px;
		& > h1 {
			color: $red;
			font-size: 20px;
			font-weight: 600;
			padding: 40px 0;
			text-align: left;
		}

		.promise-table {
			& > .promise-header,
			& > .promise-tbody {
				font-size: 17px;
				font-weight: 400;
				p {
					padding: 8px 0;
					flex-basis: 20%;
					text-align: center;
					&:first-of-type {
						flex-basis: 5%;
					}
					&:nth-child(2) {
						flex-basis: 45%;
					}
					&:last-of-type {
						flex-basis: 10%;
						cursor: pointer;
					}
				}
			}

			& > .promise-tbody {
				&:nth-of-type(even) {
					background: #f8fbfb;
				}
				p {
					padding: 10px 0;
					font-size: 14px;
					&:last-of-type {
						color: #d01c0b;
						text-decoration: underline;
					}
				}
			}

			& > .promise-header {
				background: #f4f4f4;
				border: 1px solid #e7e8ea;
			}

			& > .promise-reply {
				padding: 0 80px 30px;
				p {
					text-align: left;
					line-height: 40px;
					&:first-of-type {
						border-bottom: 1px solid #e5eaeb;
					}

					span {
						color: #d01c0b;
					}
				}
			}
		}

		.el-pagination {
			margin-top: 15px;
			text-align: right;
		}
	}
</style>